import React, { useContext, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import UnreadNotificationsBubble from 'Dashboard/components/UnreadNotificationsBubble/UnreadNotificationsBubble';
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';
import WpIcon from 'Wpds/components/icon/WpIcon';
import CreateFeedbackAIModal from 'Shared/components/modals/CreateFeedbackAIModal/CreateFeedbackAIModal';

import { trackEvent } from 'Shared/tracking/tracking';

import { useTooltip } from 'Wpds/components/tooltip/useTooltip';
import WpTooltipOverlay from 'Wpds/components/tooltip/WpTooltipOverlay';
import { WpPopover, WpPopoverContent, WpPopoverToggle } from 'Wpds/components/popover';
import YourFeedContent from './NotificationsMenu/YourFeedContent/YourFeedContent';

import { NotificationsContext } from './NotificationsProviderContext';

import './Notifications.scss';

const INIT_CREATE_AI_MODAL_OPTIONS = { isOpen: false, teammate: null, title: null };

function Notifications() {
  const { isOpen, handleSetIsOpen: setIsOpen } = useContext(NotificationsContext);
  const isExpanded = useContext(ExpandNavbarContext);
  const tooltip = useTooltip({ placement: 'right' });

  const [createActionItemModalOptions, setCreateActionItemModalOptions] = useState(INIT_CREATE_AI_MODAL_OPTIONS);

  const handleCreateActionItemClick = useCallback(
    ({ teammate, title }) => setCreateActionItemModalOptions({ isOpen: true, teammate, title }),
    []
  );

  const handleCreateActionItemModalClose = useCallback(
    () => setCreateActionItemModalOptions(INIT_CREATE_AI_MODAL_OPTIONS),
    []
  );

  const unreadWebNotificationsCount = useSelector(
    state => state.web_notifications.filter(notification => !notification?.readAt).length
  );

  const trackOpenNotifications = (value: boolean) => {
    if (value === true) {
      trackEvent('Clicked Notifications Feed');
    }
  };

  const baseClassName = 'Notifications';

  return (
    <>
      {createActionItemModalOptions.isOpen && (
        <CreateFeedbackAIModal
          isOpen
          toggleModal={handleCreateActionItemModalClose}
          title={createActionItemModalOptions.title}
          teammate={createActionItemModalOptions.teammate}
        />
      )}
      <WpPopover
        open={isOpen}
        onOpenChange={setIsOpen}
        placement="right-start"
        showArrow={false}
        event="click"
        onOpenChangeCallback={trackOpenNotifications}
        withBoxShadow
        withPadding={false}
      >
        <WpPopoverToggle>
          <li className={`${baseClassName} nav-item`} ref={tooltip.targetRef}>
            <div className={cn('nav-link d-flex align-items-center cursor-pointer', { active: isOpen })}>
              <div
                className={cn('side-navigation-icon position-relative', {
                  'mx-auto': !isExpanded,
                  Notifications__notify: !isExpanded && unreadWebNotificationsCount,
                })}
              >
                <WpIcon name="bell" />
              </div>
              {isExpanded && <div className="d-inline">Notifications</div>}
              {unreadWebNotificationsCount && isExpanded ? (
                <UnreadNotificationsBubble count={unreadWebNotificationsCount} classNames="ml-auto mr-1" />
              ) : null}
            </div>
          </li>
        </WpPopoverToggle>
        <WpPopoverContent>
          <h4 className={`${baseClassName}__title`}>Notifications</h4>
          <div className={`${baseClassName}__content scrollbar`}>
            <YourFeedContent onCreateActionItemClick={handleCreateActionItemClick} />
          </div>
          {/* <YourFeedContent onCreateActionItemClick={handleCreateActionItemClick} /> */}
        </WpPopoverContent>
      </WpPopover>
      {!isExpanded && <WpTooltipOverlay context={tooltip}> Notifications</WpTooltipOverlay>}
    </>
  );
}

export default Notifications;
